import { render, staticRenderFns } from "./RequestedPartsView.vue?vue&type=template&id=10f363d4&scoped=true&lang=pug"
import script from "./RequestedPartsView.vue?vue&type=script&lang=js"
export * from "./RequestedPartsView.vue?vue&type=script&lang=js"
import style0 from "./RequestedPartsView.vue?vue&type=style&index=0&id=10f363d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f363d4",
  null
  
)

export default component.exports